import {
	GET_BATCH_LIST,
	GET_BATCH_LIST_SUCCESS,
	GET_BATCH_LIST_FAIL,
	GET_BATCH_LIST_RESET,
} from '../actions/getBatchListAction';

const initialState = {
	apiState: '',
	message: '',
	data: [],
	error: '',
};

const getBatchListReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_BATCH_LIST:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_BATCH_LIST_SUCCESS:
			console.log("Reducer Success Action:", action);
			return {
				...state,
				apiState: 'success',
				data: action.response.data || [],
				message: action.response.message,
			};
		case GET_BATCH_LIST_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response?.errors || action.response,
				message: action.response?.message || 'Error occurred',
			};
		case GET_BATCH_LIST_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getBatchListReducer; 